import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useLazyQuery, useQuery } from '@apollo/react-hooks';
import { get, getOr } from 'lodash/fp';
import useHeaderComponentsMutation from '../../Hooks/useHeaderComponentsMutation';
import Search from '../../Components/Search/Index';
import { EVENT_TITLE } from '../../Constants/AppConstants';
import { FETCH_EVENT_SCHOOL_TEAMS, FETCH_EVENT } from '../../GraphQL/Queries';
import useCurrentUser from '../../Hooks/userCurrentUser';
import NestedList from '../../Components/NestedList/Index';

const Teams = () => {
  const {
    currentUser,
  } = useCurrentUser(true);
  const { id } = useParams();
  const [searchQuery, setSearchQuery] = useState('');
  const [fetchCoaches, { data: teamsData }] = useLazyQuery(FETCH_EVENT_SCHOOL_TEAMS);
  const teams = getOr([], 'eventSchoolTeams', teamsData);

  const { data } = useQuery(
    FETCH_EVENT,
    {
      variables: { id: parseInt(id, 10) },
    },
  );
  const event = getOr({}, 'fetchEventDetail', data);

  useEffect(() => {
    if (currentUser) {
      fetchCoaches({
        variables: {
          eventId: id,
        },
      });
    }
  }, [currentUser, fetchCoaches, id]);

  const searchTeam = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredTeams = searchQuery === ''
    ? teams
    : teams.filter((team) => team.school.name.toLowerCase().includes(searchQuery.trimStart().toLowerCase()));

  useHeaderComponentsMutation({
    title: 'TEAMS',
    backLink: `/event-manage/${id}`,
    components: [{ key: EVENT_TITLE, value: get('title', event) }],
  });

  return (
    <>
      <div className="mt-4" />
      <Search
        placeholder="Search"
        onChange={searchTeam}
      />
      <NestedList data={filteredTeams} displayAttribute="name" redirectLink="event" redirectOperation="teams" dataType="schools" optionalId={id} />
    </>
  );
};
export default Teams;
